<template>
  <div class="register-info-container">
    <!-- 表单视图 -->
    <div>
      <!-- 预填信息展示 -->
      <div class="pre-filled-info d-flex d-flex-between d-flex-middle">
        <div class="info-item">
          <span class="label">主考学校:</span>
          <span class="value">{{ helpInfo.school.code+'-'+helpInfo.school.name }}</span>
        </div>
        <div class="info-item">
          <span class="label">报名专业:</span>
          <span class="value">{{ specialtyName }}</span>
        </div>
        <div class="info-item">
          <span class="label">助学点:</span>
          <span class="value">{{ helpInfo.code+'-'+helpInfo.name }}</span>
        </div>
      </div>

      <!-- 注册资料表单 -->
      <el-form :model="form" :rules="rules" ref="registerForm" label-width="160px" class="register-form" size="small">
      <el-row :gutter="40">
        <el-col :span="12">
          <el-form-item label="姓名" prop="name">
            <el-input v-model="form.name" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="民族" prop="nation">
            <el-select v-model="form.nation" placeholder="请选择" clearable class="full-width">
              <el-option 
                :label="item.label" 
                :value="item.value" 
                v-for="(item, index) in nationOptions" 
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="证件类型" prop="idType">
            <el-select v-model="form.idType" placeholder="请选择" clearable class="full-width">
              <el-option 
                :label="item.label" 
                :value="item.value" 
                v-for="(item, index) in idTypeOptions" 
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="证件号码" prop="idCardNumber">
            <el-input v-model="form.idCardNumber" placeholder="请输入" clearable @blur="handleIdCardBlur"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="性别" prop="gender">
            <el-select v-model="form.gender" placeholder="请选择" clearable class="full-width">
              <el-option 
                :label="item.label" 
                :value="item.value" 
                v-for="(item, index) in genderOptions" 
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="出生日期" prop="birthday">
            <el-date-picker
              v-model="form.birthday"
              type="date"
              placeholder="请选择"
              value-format="yyyy-MM-dd"
              class="full-width"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="手机号" prop="phone">
            <el-input v-model="form.phone" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="常住地" prop="registerProvince">
            <el-cascader
              v-model="registerAddressArr"
              :options="addressOptions"
              :props="cascaderProps"
              @change="handleAddressChange"
              placeholder="请选择省市区"
              clearable
              class="full-width"
            ></el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="通讯地址" prop="contactAddress">
            <el-input v-model="form.contactAddress" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>

       
        <el-col :span="12">
          <el-form-item label="原最高学历" prop="oldEducation">
            <el-select v-model="form.oldEducation" placeholder="请选择" clearable class="full-width">
              <el-option 
                :label="item.label" 
                :value="item.value" 
                v-for="(item, index) in educationOptions" 
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="家庭联系人关系" prop="contactRelationship">
            <el-input v-model="form.contactRelationship" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        
        <el-col :span="12">
          <el-form-item label="家庭联系人姓名" prop="contactName">
            <el-input v-model="form.contactName" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="家庭联系人手机号" prop="contactPhone">
            <el-input v-model="form.contactPhone" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        
        
        
      </el-row>
      </el-form>

      <!-- 提示信息 -->
      <div class="tip-message">
        <span class="tip-text">提示:报考专升本层次的学员,必须在申请专升本层次毕业证前获得专科层次学历</span>
      </div>

      <!-- 底部按钮 -->
      <div class="action-buttons d-flex d-flex-middle d-flex-center">
        <el-button class="prev-btn" @click="handlePrev">上一步</el-button>
        <el-button type="primary" class="next-btn" @click="handleNext">下一步</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import addressData from '@/data/address.js'

export default {
  name: 'RegisterInfo',
  props: {
    // 是否需要从接口查询学生信息（用于 mineBm 场景的数据回显）
    needQueryStudentInfo: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      MOCK_PREFIX: process.env.VUE_APP_MOCK_PREFIX || '',
      helpInfo: {},
      specialtyName:'',
      form: {
        name: '',
        idType: '',
        gender: '',
        registerProvince: '',
        registerCity: '',
        registerRegion: '',
        oldEducation: '',
        contactName: '',
        phone: '',
        nation: '',
        idCardNumber: '',
        birthday: '',
        contactAddress: '',
        contactRelationship: '',
        contactPhone: '',
        helpId: '',
        specialtyId: '',
        schoolId: ''
      },
      idTypeOptions: [],
      educationOptions: [],
      nationOptions: [],
      genderOptions: [],
      registerAddressArr: [], // 级联选择器的值数组
      addressOptions: [], // 处理后的地址选项
      cascaderProps: {
        value: 'code',
        label: 'name',
        children: 'children',
        expandTrigger: 'hover'
      },
      
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        idType: [
          { required: true, message: '请选择证件类型', trigger: 'change' }
        ],
        idCardNumber: [
          { required: true, message: '请输入证件号码', trigger: 'blur' }
        ],
        nation: [
          { required: true, message: '请选择民族', trigger: 'change' }
        ],
        gender: [
          { required: true, message: '请选择性别', trigger: 'change' }
        ],
        birthday: [
          { required: true, message: '请选择出生日期', trigger: 'change' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        registerProvince: [
          { 
            required: true, 
            message: '请选择常住地', 
            trigger: 'change',
            validator: (rule, value, callback) => {
              if (!this.form.registerProvince || !this.form.registerCity || !this.form.registerRegion) {
                callback(new Error('请选择完整的省市区'))
              } else {
                callback()
              }
            }
          }
        ],
        contactAddress: [
          { required: true, message: '请输入通讯地址', trigger: 'blur' }
        ],
        oldEducation: [
          { required: true, message: '请选择原最高学历', trigger: 'change' }
        ],
        // contactName: [
        //   { required: true, message: '请输入联系人姓名', trigger: 'blur' }
        // ],
        // contactRelationship: [
        //   { required: true, message: '请输入联系人关系', trigger: 'blur' }
        // ],
        // contactPhone: [
        //   { required: true, message: '请输入联系人手机号', trigger: 'blur' },
        //   { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        // ]
      }
    }
  },
  watch: {
    // 监听地址选项和表单数据，当两者都准备好时自动设置回显
    addressOptions: {
      handler() {
        if (this.addressOptions.length > 0 && this.form.registerProvince && this.form.registerCity && this.form.registerRegion) {
          this.setAddressDisplay()
        }
      },
      immediate: true
    }
  },
  created() {
    this.loadRegionData()
    this.getDictData()
    this.getPreFillInfo()
  },
  methods: {
    loadRegionData() {
      // 将 addressData 转换为三级结构
      this.addressOptions = addressData.map(province => {
        // 判断是否为直辖市（北京、上海、天津、重庆）
        const isDirectCity = [110000, 120000, 310000, 500000].includes(province.code)
        if (isDirectCity) {
          return {
            code: province.code,
            name: province.name,
            children: [{
              code: province.code,
              name: province.name,
              children: province.children.map(district => ({
                code: district.code,
                name: district.name
              }))
            }]
          }
        } else {
          // 普通省份：省 -> 市 -> 区
          return {
            code: province.code,
            name: province.name,
            children: province.children.map(city => {
              // 如果市有 children（区），使用；否则将市本身作为区
              if (city.children && city.children.length > 0) {
                return {
                  code: city.code,
                  name: city.name,
                  children: city.children.map(district => ({
                    code: district.code,
                    name: district.name
                  }))
                }
              } else {
                // 没有区数据，将市本身作为区
                return {
                  code: city.code,
                  name: city.name,
                  children: [{
                    code: city.code,
                    name: city.name
                  }]
                }
              }
            })
          }
        }
      })
    },
    // 根据地址代码获取地址名称
    getAddressName(code) {
      if (!code) return ''
      // 统一转换为数字进行比较（地址数据中的code是数字类型）
      const codeNum = typeof code === 'string' ? parseInt(code) : code
      if (isNaN(codeNum)) return code
      
      // 遍历省份
      for (const province of this.addressOptions) {
        if (province.code === codeNum) {
          return province.name
        }
        // 遍历城市
        if (province.children) {
          for (const city of province.children) {
            if (city.code === codeNum) {
              return city.name
            }
            // 遍历区县
            if (city.children) {
              for (const district of city.children) {
                if (district.code === codeNum) {
                  return district.name
                }
              }
            }
          }
        }
      }
      return code
    },
    // 根据地址名称获取地址代码
    getAddressCode(name) {
      if (!name) return ''
      // 如果已经是代码（数字），直接返回
      if (/^\d+$/.test(String(name))) {
        return name
      }
      
      // 遍历省份
      for (const province of this.addressOptions) {
        if (province.name === name) {
          return province.code
        }
        // 遍历城市
        if (province.children) {
          for (const city of province.children) {
            if (city.name === name) {
              return city.code
            }
            // 遍历区县
            if (city.children) {
              for (const district of city.children) {
                if (district.name === name) {
                  return district.code
                }
              }
            }
          }
        }
      }
      return name
    },
    // 地址选择变化处理
    handleAddressChange(value) {
      if (value && value.length === 3) {
        // 级联选择器的值（代码）会自动更新到 registerAddressArr
        // 将代码转换为名称存储到 form
        this.form.registerProvince = this.getAddressName(value[0])
        this.form.registerCity = this.getAddressName(value[1])
        this.form.registerRegion = this.getAddressName(value[2])
      } else {
        // 清空时，也要清空 form 中的值
        this.form.registerProvince = ''
        this.form.registerCity = ''
        this.form.registerRegion = ''
        this.registerAddressArr = []
      }
      // 触发表单验证
      this.$refs.registerForm.validateField('registerProvince')
    },
    // 设置地址回显
    setAddressDisplay() {
      if (this.form.registerProvince && this.form.registerCity && this.form.registerRegion && this.addressOptions.length > 0) {
        let provinceCode = this.form.registerProvince
        let cityCode = this.form.registerCity
        let regionCode = this.form.registerRegion
        
        // 如果是名称，转换为代码
        if (!/^\d+$/.test(String(provinceCode))) {
          provinceCode = this.getAddressCode(provinceCode)
        }
        if (!/^\d+$/.test(String(cityCode))) {
          cityCode = this.getAddressCode(cityCode)
        }
        if (!/^\d+$/.test(String(regionCode))) {
          regionCode = this.getAddressCode(regionCode)
        }
        
        // 如果都转换成功（都是代码），设置级联选择器
        if (/^\d+$/.test(String(provinceCode)) && /^\d+$/.test(String(cityCode)) && /^\d+$/.test(String(regionCode))) {
          this.$nextTick(() => {
            this.registerAddressArr = [provinceCode, cityCode, regionCode]
          })
        }
      }
    },
    // 身份证号码失焦处理 - 自动填充性别和出生日期
    handleIdCardBlur() {
      // 判断证件类型是否为身份证
      if (!this.form.idType) {
        return
      }
      
      // 查找身份证类型（通过label判断，通常包含"身份证"或"居民身份证"）
      const idTypeItem = this.idTypeOptions.find(item => item.value === this.form.idType)
      if (!idTypeItem || !idTypeItem.label || !idTypeItem.label.includes('身份证')) {
        return
      }
      
      const idCard = this.form.idCardNumber && this.form.idCardNumber.trim()
      if (!idCard) {
        return
      }
      
      // 验证身份证号码格式（15位或18位）
      const idCardRegex = /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$|^[1-9]\d{5}\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}$/
      if (!idCardRegex.test(idCard)) {
        return
      }
      
      // 解析身份证号码
      this.parseIdCard(idCard)
    },
    // 解析身份证号码，提取性别和出生日期
    parseIdCard(idCard) {
      let genderCode = ''
      let birthdayStr = ''
      
      if (idCard.length === 18) {
        // 18位身份证
        // 第17位（索引16）表示性别：奇数为男，偶数为女
        genderCode = idCard.charAt(16)
        // 第7-14位（索引6-13）表示出生日期：YYYYMMDD
        birthdayStr = idCard.substring(6, 14)
      } else if (idCard.length === 15) {
        // 15位身份证
        // 第15位（索引14）表示性别：奇数为男，偶数为女
        genderCode = idCard.charAt(14)
        // 第7-12位（索引6-11）表示出生日期：YYMMDD，需要加19前缀
        birthdayStr = '19' + idCard.substring(6, 12)
      } else {
        return
      }
      
      // 解析出生日期：YYYYMMDD -> YYYY-MM-DD
      // 仅在出生日期为空时自动填充
      if (birthdayStr.length === 8 && !this.form.birthday) {
        const year = birthdayStr.substring(0, 4)
        const month = birthdayStr.substring(4, 6)
        const day = birthdayStr.substring(6, 8)
        
        // 验证日期有效性
        const date = new Date(year, parseInt(month) - 1, day)
        if (date.getFullYear() == year && date.getMonth() == parseInt(month) - 1 && date.getDate() == day) {
          this.form.birthday = `${year}-${month}-${day}`
        }
      }
      
      // 解析性别：奇数为男，偶数为女
      // 仅在性别为空时自动填充
      if (genderCode && this.genderOptions.length > 0 && !this.form.gender) {
        const genderNum = parseInt(genderCode)
        if (!isNaN(genderNum)) {
          const isMale = genderNum % 2 === 1
          
          // 查找性别选项：优先匹配label包含"男"或"女"的选项
          let genderValue = null
          
          // 尝试多种匹配方式
          const maleKeywords = ['男', 'male', '1']
          const femaleKeywords = ['女', 'female', '2']
          
          if (isMale) {
            // 查找男性选项
            genderValue = this.genderOptions.find(item => {
              const label = (item.label || '').toLowerCase()
              const value = String(item.value || '')
              return maleKeywords.some(keyword => 
                label.includes(keyword.toLowerCase()) || 
                value === keyword ||
                (keyword === '1' && value === '1')
              )
            })
          } else {
            // 查找女性选项
            genderValue = this.genderOptions.find(item => {
              const label = (item.label || '').toLowerCase()
              const value = String(item.value || '')
              return femaleKeywords.some(keyword => 
                label.includes(keyword.toLowerCase()) || 
                value === keyword ||
                (keyword === '2' && value === '2')
              )
            })
          }
          
          // 如果找到匹配的选项，设置性别值
          if (genderValue) {
            this.form.gender = genderValue.value
          }
        }
      }
    },
    getDictData() {
      this.$http.post('/student/common/getDictItemByTypes', ['id_type', 'eduleveles', 'nation','gender']).then(res => {
        if (res.id_type) {
          this.idTypeOptions = res.id_type
        }
        if (res.eduleveles) {
          this.educationOptions = res.eduleveles
        }
        if (res.nation) {
          this.nationOptions = res.nation
        }
        if (res.gender) {
          this.genderOptions = res.gender
        }
      }).catch(err => {
        console.error('获取字典数据失败:', err)
      })
    },
    getPreFillInfo() {
      this.helpInfo = JSON.parse(localStorage.getItem('helpInfo')) || {}
      const specId = localStorage.getItem('specId')
      if (specId) {
        this.$http.get(this.MOCK_PREFIX + '/student/pc/getSpecialtyList/'+specId+'?target_id=21849fb0f0705f').then(res => {
          this.specialtyName = res.code+'-'+res.name
        })
      }
      
      // 如果需要从接口查询学生信息（mineBm 场景）
      if (this.needQueryStudentInfo) {
        this.$http.get(this.MOCK_PREFIX + '/student/pc/register/queryStudentInfo?target_id=22b542ab707097').then(res => {
          if (res) {
            // 使用 $set 确保响应式更新
            Object.keys(res).forEach(key => {
              if (key !== 'contactList') {
                this.$set(this.form, key, res[key] || '')
              }
            })
            
            // 处理常住地：如果返回的是代码，转换为名称；如果是名称，直接使用
            let registerProvince = res.registerProvince
            let registerCity = res.registerCity
            let registerRegion = res.registerRegion
            
            // 判断是否为代码（代码通常是数字）
            if (registerProvince && /^\d+$/.test(String(registerProvince))) {
              registerProvince = this.getAddressName(registerProvince)
            }
            if (registerCity && /^\d+$/.test(String(registerCity))) {
              registerCity = this.getAddressName(registerCity)
            }
            if (registerRegion && /^\d+$/.test(String(registerRegion))) {
              registerRegion = this.getAddressName(registerRegion)
            }
            
            // 使用转换后的地址名称
            this.$set(this.form, 'registerProvince', registerProvince || '')
            this.$set(this.form, 'registerCity', registerCity || '')
            this.$set(this.form, 'registerRegion', registerRegion || '')
            
            // 处理 helpId、schoolId、specialtyId
            this.$set(this.form, 'helpId', this.helpInfo.id || res.helpId || '')
            this.$set(this.form, 'specialtyId', specId || res.specialtyId || '')
            this.$set(this.form, 'schoolId', this.helpInfo.school?.id || res.schoolId || '')
            
            // 处理联系人列表：参考 completeInfo.vue 的处理方式
            if (res.contactList && Array.isArray(res.contactList) && res.contactList.length > 0) {
              // 直接使用接口返回的 contactList
              this.$set(this.form, 'contactList', res.contactList.map(contact => ({
                contactName: contact.contactName || '',
                contactRelationship: contact.contactRelationship || '',
                contactPhone: contact.contactPhone || ''
              })))
            } else {
              // 如果没有 contactList，至少保留一个空联系人
              this.$set(this.form, 'contactList', [{
                contactName: '',
                contactRelationship: '',
                contactPhone: ''
              }])
            }
            
            // 兼容旧字段：如果 contactList 存在，同步到旧字段（用于表单验证）
            if (this.form.contactList && this.form.contactList.length > 0) {
              const firstContact = this.form.contactList[0]
              this.$set(this.form, 'contactName', firstContact.contactName || '')
              this.$set(this.form, 'contactRelationship', firstContact.contactRelationship || '')
              this.$set(this.form, 'contactPhone', firstContact.contactPhone || '')
            }
            
            // 数据设置完成后，触发地址回显
            this.$nextTick(() => {
              this.setAddressDisplay()
              // 确保组件能够接收到更新
              if (this.$refs.registerForm) {
                this.$refs.registerForm.$forceUpdate()
              }
            })
          }
        }).catch(err => {
          console.error('获取学生信息失败:', err)
          // 接口失败时，尝试从 localStorage 加载
          this.loadFromLocalStorage(specId)
        })
      } else {
        // 原有逻辑：从 localStorage 加载
        this.loadFromLocalStorage(specId)
      }
    },
    loadFromLocalStorage(specId) {
      const savedFormData = localStorage.getItem('registerFormData')
      if (savedFormData) {
        try {
          const formData = JSON.parse(savedFormData)
          formData.helpId = this.helpInfo.id
          formData.specialtyId = specId
          formData.schoolId = this.helpInfo.school?.id
          
          // 处理常住地：如果存储的是代码，转换为名称；如果是名称，直接使用
          if (formData.registerProvince && /^\d+$/.test(String(formData.registerProvince))) {
            formData.registerProvince = this.getAddressName(formData.registerProvince)
          }
          if (formData.registerCity && /^\d+$/.test(String(formData.registerCity))) {
            formData.registerCity = this.getAddressName(formData.registerCity)
          }
          if (formData.registerRegion && /^\d+$/.test(String(formData.registerRegion))) {
            formData.registerRegion = this.getAddressName(formData.registerRegion)
          }
          
          this.form = formData
          
          // 数据设置完成后，触发地址回显
          this.$nextTick(() => {
            this.setAddressDisplay()
          })
        } catch (e) {
          console.error('解析保存的表单数据失败:', e)
        }
      }
    },
    handlePrev() {
      this.$emit('prev-step')
    },
    // 点击下一步：验证表单，通过后跳转到步骤4
    handleNext() {
      this.$refs.registerForm.validate((valid) => {
        if (!valid) {
          this.$message.error('请完善必填信息')
          return false
        }
        localStorage.setItem('registerFormData', JSON.stringify(this.form))
        this.$emit('next-step')
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.register-info-container {
  width: 100%;
  padding: 30px 0;
}

.pre-filled-info {
  background: #EEF6FE;
  box-sizing: border-box;
  padding: 0 40px;
  border-radius: 10px;
  margin-bottom: 30px;
  height: 48px;

  .info-item {
    font-size: 14px;

    &:last-child {
      margin-bottom: 0;
    }

    .label {
      color: #767676;
      margin-right: 8px;
      font-weight: 500;
    }

    .value {
      color: #303133;
    }
  }
}

.register-form {
  ::v-deep .el-form-item {
    margin-bottom: 15px;
  }

  ::v-deep .el-form-item__label {
    font-size: 14px;
    color: #303133;
    font-weight: 500;
  }

  .full-width {
    width: 100%;
  }
}

.tip-message {
  margin-top: 20px;
  margin-bottom: 30px;

  .tip-text {
    color: #f56c6c;
    font-size: 14px;
  }
}

.action-buttons {
  gap: 20px;
  padding-top: 20px;

  .prev-btn {
    width: 160px;
    height: 40px;
    background: #fff;
    border: 1px solid #1890ff;
    color: #1890ff;
    border-radius: 8px;
    font-size: 16px;

    &:hover {
      background: #f0f7ff;
    }
  }

  .next-btn {
    width: 160px;
    height: 40px;
    background: #1890ff;
    border: none;
    border-radius: 8px;
    color: #fff;
    font-size: 16px;

    &:hover {
      background: #40a9ff;
    }
  }
}
</style>
